import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  IconButton,
  Tab,
  Tabs,
  Typography,
  Box,
  Divider,
  Menu,
  MenuItem,
} from "@mui/material";
// import FolderIcon from "@mui/icons-material/Folder";
import FolderOpenOutlinedIcon from '@mui/icons-material/FolderOpenOutlined';
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import ThumbDownIcon from "@mui/icons-material/ThumbDown";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useUser } from "../../hooks/Authorize";
import CloseIcon from "@mui/icons-material/Close";
import axios from "axios";
import { useLocation } from 'react-router-dom';
import { useTheme } from "../../style/theme";

const MoveDialog = ({ openModal, handleCloseModal, item, setClikkleItems, isAddToShortCutDialog = false, setProcessingMessage, setShowProcessingSnackbar }) => {
  const [selectedTab, setSelectedTab] = useState(0);
  const [currentPath, setCurrentPath] = useState("root");
  const [folderData, setFolderData] = useState({});
  const platformUser = JSON.parse(localStorage.getItem("user"));
  const [navigationHistory, setNavigationHistory] = useState(["root"]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [activeFolder, setActiveFolder] = useState(null);
  const [currentFolderName, setCurrentFolderName] = useState(null);
  const { mode } = useTheme();

  const location = useLocation();

  useEffect(() => {
    if (openModal) {
      fetchFolders();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openModal]);

  const fetchFolders = async (parentId = null) => {
    try {
      // For All Locations tab at root level
      if (selectedTab === 2 && !parentId) {
        // Clear any previous tab data and set "My Files" as root

        // eslint-disable-next-line no-useless-computed-key
        setFolderData({
          // eslint-disable-next-line no-useless-computed-key
          ["root"]: [{
            // eslint-disable-next-line no-useless-computed-key
            _id: platformUser._id,
            name: "My Files",
            type: "folder",
            isVirtual: true
          }]
        });
        return;
      }

      let queryParam = "";

      if (selectedTab === 0) {
        queryParam = "&recentFolders=true"; // Suggested
      } else if (selectedTab === 1) {
        queryParam = "&isStarred=true"; // Starred
      }

      const url = parentId
        ? `${process.env.REACT_APP_NODE_FILE_MANAGER_SERVER}/api/fs?ownerId=${platformUser._id}&parentId=${parentId}`
        : `${process.env.REACT_APP_NODE_FILE_MANAGER_SERVER}/api/fs?ownerId=${platformUser._id}${queryParam}`;

      const response = await fetch(url);
      const data = await response.json();

      setFolderData(prevData => ({
        ...prevData,
        [parentId || "root"]: data.filter(item => item.type === "folder"),
      }));
    } catch (error) {
      console.error("Error fetching folders:", error);
    }
  };

  useEffect(() => {
    if (openModal) {
      fetchFolders();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openModal, selectedTab]);

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
    if (newValue === 2) { // All Locations selected
      setCurrentPath("root");
      setNavigationHistory(["root"]);
    }
  };

  const handleMoveBtnClick = async () => {
    if (!item?._id) {
      console.error("Missing item ID");
      return;
    }

    var message = isAddToShortCutDialog ? "Creating Shortcut..." : `Moving ${item.name}`

    setProcessingMessage(message);
    setShowProcessingSnackbar(true)

    if (isAddToShortCutDialog) {
      try {
        var parentId = activeFolder || null;
        if (activeFolder === platformUser._id) {
          parentId = null
        }
        const payload = {
          originalResourceId: item._id,
          parentId: parentId, // If no active folder, set to null
          ownerId: platformUser._id,
          userId: platformUser._id
        };


        const response = await axios.post(`${process.env.REACT_APP_NODE_FILE_MANAGER_SERVER}/api/fs/createShortcut`, payload);

        if (response.status === 200) {
          console.log("Create Shortcut successful:", response.data);

          // Get current parentId from URL (React Router version)
          const searchParams = new URLSearchParams(location.search);
          const currentLocationParentId = searchParams.get('parentId') || null;

          // Compare with shortcut's parentId
          const shortcutParentId = response.data.parentId || null;

          if (shortcutParentId === currentLocationParentId) {
            setClikkleItems(prevItems => {
              if (!prevItems) return [response.data];
              const exists = prevItems.some(i => i._id === response.data._id);
              return exists ? prevItems : [response.data, ...prevItems];
            });
          }

          handleCloseModal();
        } else {
          console.error("Create Shortcut failed:", response.data);
        }
      } catch (error) {
        console.error("Error Creating Shortcut item:", error);
      }
    } else {
      try {
        var payload = {
          newParentId: activeFolder || null, // If no active folder, set to null
          resourceId: item._id,
          userId: platformUser._id
        };
        if (payload.newParentId === platformUser._id) {
          payload.newParentId = null
        }
        const response = await axios.post(`${process.env.REACT_APP_NODE_FILE_MANAGER_SERVER}/api/fs/move`, payload);

        if (response.status === 200) {
          console.log("Move successful:", response.data);

          setClikkleItems((prevItems) => {
            // Remove item from current location
            const updatedItems = prevItems?.filter((i) => i._id !== item._id);
            return updatedItems; // If no active folder, just remove the item
          });

          handleCloseModal()

        } else {
          console.error("Move failed:", response.data);
        }
      } catch (error) {
        console.error("Error moving item:", error);
      }
    }

    setShowProcessingSnackbar(false)


  };

  const handleMoreClick = (event, folderId) => {
    setAnchorEl(event.currentTarget);
    setActiveFolder(folderId);
  };


  const handleMoreClose = () => {
    setAnchorEl(null);
  };

  const handleNavigateFolder = (folderId, folderName) => {
    setCurrentFolderName(folderName)
    if (!folderData[folderId]) {
    }
    fetchFolders(folderId);
    setNavigationHistory((prev) => [...prev, folderId]);
    setCurrentPath(folderId);
    setActiveFolder(null);
  };

  const handleBackNavigation = () => {
    if (navigationHistory.length > 1) {
      const updatedHistory = [...navigationHistory];
      updatedHistory.pop();
      setCurrentPath(updatedHistory[updatedHistory.length - 1]);
      setNavigationHistory(updatedHistory);
    }
  };

  return (
    <Dialog
      open={openModal}
      onClose={handleCloseModal}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          // backgroundColor: "#191919",
          // background: "rgba(31, 31, 31, 1)",
          // 
          background: mode === 'dark' ? "rgba(31, 31, 31, 1)" : "rgb(255, 255, 255)",
          borderRadius: "12px",
          padding: "5px 10px",
          minHeight: "600px",

          maxHeight: "600px",
        },
      }}
    >
      {/* Dialog Title */}
      {/* <DialogTitle sx={{ fontSize: "16px", fontWeight: 600, display: "flex", justifyContent: "space-between", paddingBottom:0 }}>
        {currentPath === "root" ? `Move "${item?.name}"` : (
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <IconButton disableRipple onClick={handleBackNavigation} sx={{  }}>
              <ArrowBackIcon />
            </IconButton>
            {currentPath}
          </Box>
        )}
        <IconButton onClick={handleCloseModal} sx={{  }}>
        <CloseIcon />
        </IconButton>
      </DialogTitle> */}

      <DialogTitle sx={{ fontSize: "16px", fontWeight: 600, display: "flex", justifyContent: "space-between", paddingBottom: 0 }}>
        {!isAddToShortCutDialog ? "Move" : "Add shortcut to"} "{item?.name}"
        <IconButton onClick={handleCloseModal} sx={{}}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>


      {/* Current Location */}
      <Box sx={{ px: 3, pb: 1, display: "flex", alignItems: "center", gap: 1 }}>
        <Typography sx={{
          fontSize: "14px",
          //  color: "rgba(255, 255, 255, 0.6)"  
          color: mode === 'dark' ? "rgba(255, 255, 255, 0.6)" : "rgb(85, 85, 85)",

        }}>
          Current Location:
        </Typography>
        <Button
          variant="outlined"
          sx={{
            borderColor: mode === 'dark' ? "rgba(255, 255, 255, 0.3)" : "rgba(97, 97, 97, 0.42)",

            textTransform: "none",
            fontSize: "14px",
            borderRadius: "8px",
            px: 1.5,
          }}
        >
          📁 My Files
        </Button>
      </Box>

      {/* Tabs or Folder Navigation View */}
      <Box
        sx={{
          borderBottom: "1px solid rgba(255, 255, 255, 0.2)",
          px: 2,
          py: 1,
          display: "flex",
          alignItems: "center",
        }}
      >
        {currentPath === "root" ? (
          <Tabs value={selectedTab} onChange={handleTabChange} sx={{ flexGrow: 1 }}>
            <Tab label="Suggested" sx={{ textTransform: "none", }} />
            <Tab label="Starred" sx={{ textTransform: "none", }} />
            <Tab label="All Locations" sx={{ textTransform: "none", }} />
          </Tabs>

        ) : (
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <IconButton disableRipple onClick={handleBackNavigation} sx={{}}>
              <ArrowBackIcon />
            </IconButton>
            <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
              {currentFolderName}

            </Typography>
          </Box>
        )}
      </Box>

      {/* File List with Fixed Height */}
      <DialogContent sx={{ padding: 0, maxHeight: "400px", overflowY: "auto" }}>
        <List>
          {folderData[currentPath]?.map((folder) => {
            return folder.name !== item.name && (
              <ListItem
                key={folder._id}
                sx={{
                  px: 3,
                  position: "relative",
                  py: 0,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  height: "38px", // Explicit height
                  boxSizing: "border-box", // Prevent padding from affecting height
                  // Hover styles (background only - no layout changes)
                  "&:hover": {
                    backgroundColor: "rgba(255,255,255,0.1)",
                    // Forcefully disable all transforms/positioning
                    transform: "none",
                    paddingTop: "0px", // Match original py:1.5 (1.5 * 8 = 12px)
                    paddingBottom: "0px",
                  },
                  // Disable MUI's default hover effects
                  "&.MuiListItem-root": {
                    transition: "none", // Remove all transitions
                    "&:hover": {
                      transform: "none",
                    },
                  },
                  transform: "none", // Disable any scaling
                  transition: "background-color 0.2s ease", // Smooth background transition only
                }}
                onMouseEnter={() => setActiveFolder(folder._id)}
                onMouseLeave={() => setActiveFolder(null)}
              >
                <Box sx={{ display: "flex", alignItems: "center", gap: 1, width: "75%" }}>
                  <ListItemIcon sx={{ minWidth: "30px", }}>
                    <FolderOpenOutlinedIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary={folder.name}
                    sx={{

                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis"
                    }}
                  />
                </Box>
                {activeFolder === folder._id && (
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <Button
                      onClick={handleMoveBtnClick}
                      variant="contained"
                      sx={{
                        backgroundColor: "rgba(30, 101, 216, 0.21)",
                        color: "rgb(30, 101, 216)",
                        textTransform: "none",
                        fontSize: "12px",
                        px: 2,
                        py: 0.5,
                        borderRadius: "16px",
                        "&:hover": {
                          backgroundColor: "rgba(30, 101, 216, 0.21)"
                        },
                      }}
                    >
                      {!isAddToShortCutDialog ? "Move" : "Add"}
                    </Button>

                    <Box sx={{ position: 'relative' }}>
                      <IconButton
                        disableRipple
                        onClick={(e) => {
                          e.stopPropagation();
                          handleMoreClick(e, folder._id);
                        }}
                        sx={{}}
                      >
                        <MoreVertIcon />
                      </IconButton>

                      <Menu
                        anchorEl={anchorEl}
                        open={Boolean(anchorEl)}
                        onClose={handleMoreClose}
                        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                        transformOrigin={{ vertical: "top", horizontal: "right" }}
                      >
                        <MenuItem
                          onClick={() => {
                            // Remove the folder from the current view
                            setFolderData(prev => ({
                              ...prev,
                              [currentPath]: prev[currentPath].filter(f => f._id !== activeFolder)
                            }));
                            handleMoreClose();
                          }}
                        >
                          <ListItemIcon>
                            <ThumbDownIcon fontSize="small" />
                          </ListItemIcon>
                          Not Useful
                        </MenuItem>
                      </Menu>
                    </Box>

                    <IconButton
                      disableRipple
                      onClick={() => handleNavigateFolder(folder._id, folder.name)}
                      sx={{}}
                    >
                      <ArrowForwardIosIcon sx={{ fontSize: "14px" }} />
                    </IconButton>
                  </Box>
                )}
              </ListItem>
            )
          })}
        </List>


      </DialogContent>

      {/* MoreVert Menu */}
      {/* <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMoreClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <MenuItem  >
          <ListItemIcon>
            <ThumbDownIcon fontSize="small" />
          </ListItemIcon>
          Not Useful
        </MenuItem>
      </Menu> */}

      {/* Footer */}
      <Divider sx={{ backgroundColor: "rgba(255, 255, 255, 0.2)" }} />
      <DialogActions sx={{ justifyContent: "flex-end", padding: "16px" }}>
        <Button onClick={handleCloseModal} sx={{ textTransform: "none", fontSize: "14px" }}>
          Cancel
        </Button>
        <Button disabled sx={{ backgroundColor: "rgba(255,255,255,0.3)", borderRadius: "8px", textTransform: "none", fontSize: "14px" }}>
          {!isAddToShortCutDialog ? "Move" : "Add"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default MoveDialog;
